import { render, staticRenderFns } from "./portal-login-template.vue?vue&type=template&id=688ed9d9&"
import script from "./portal-login-template.vue?vue&type=script&lang=ts&"
export * from "./portal-login-template.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports